import React, { Component } from "react";
import { Row, Col, Form, Button, Table, Badge } from "react-bootstrap";

/**
 * ColumnConfigEditor - Add/remove/reorder columns for a widget instance.
 * Edits the columnsConfig JSON array.
 *
 * Props:
 *   - columns: Array of column config objects
 *   - onChange: Callback with updated columns array
 */
export default class ColumnConfigEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: props.columns || [],
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.columns !== this.props.columns) {
      this.setState({ columns: this.props.columns || [] });
    }
  }

  addColumn = () => {
    const columns = [
      ...this.state.columns,
      { field: "", header: "", sortable: true, type: "text", width: "" },
    ];
    this.setState({ columns });
    this.props.onChange && this.props.onChange(columns);
  };

  removeColumn = (index) => {
    const columns = this.state.columns.filter((_, i) => i !== index);
    this.setState({ columns });
    this.props.onChange && this.props.onChange(columns);
  };

  updateColumn = (index, field, value) => {
    const columns = [...this.state.columns];
    columns[index] = { ...columns[index], [field]: value };
    this.setState({ columns });
    this.props.onChange && this.props.onChange(columns);
  };

  moveColumn = (index, direction) => {
    const toIndex = index + direction;
    if (toIndex < 0 || toIndex >= this.state.columns.length) return;
    const columns = [...this.state.columns];
    [columns[index], columns[toIndex]] = [columns[toIndex], columns[index]];
    this.setState({ columns });
    this.props.onChange && this.props.onChange(columns);
  };

  render() {
    const { columns } = this.state;

    return (
      <div>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <span>
            <strong>Columns</strong>{" "}
            <Badge bg="secondary">{columns.length}</Badge>
          </span>
          <Button variant="outline-primary" size="sm" onClick={this.addColumn}>
            <i className="bi bi-plus me-1"></i>Add Column
          </Button>
        </div>

        <Table size="sm" bordered hover responsive>
          <thead>
            <tr>
              <th style={{ width: "30px" }}>#</th>
              <th>Field</th>
              <th>Header</th>
              <th style={{ width: "100px" }}>Type</th>
              <th style={{ width: "60px" }}>Sort</th>
              <th style={{ width: "80px" }}>Width</th>
              <th style={{ width: "100px" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {columns.map((col, index) => (
              <tr key={index}>
                <td className="text-center">{index + 1}</td>
                <td>
                  <Form.Control
                    type="text"
                    size="sm"
                    value={col.field || ""}
                    onChange={(e) => this.updateColumn(index, "field", e.target.value)}
                    placeholder="field_name"
                  />
                </td>
                <td>
                  <Form.Control
                    type="text"
                    size="sm"
                    value={col.header || ""}
                    onChange={(e) => this.updateColumn(index, "header", e.target.value)}
                    placeholder="Display Name"
                  />
                </td>
                <td>
                  <Form.Select
                    size="sm"
                    value={col.type || "text"}
                    onChange={(e) => this.updateColumn(index, "type", e.target.value)}
                  >
                    <option value="text">Text</option>
                    <option value="number">Number</option>
                    <option value="date">Date</option>
                    <option value="boolean">Boolean</option>
                  </Form.Select>
                </td>
                <td className="text-center">
                  <Form.Check
                    type="switch"
                    checked={col.sortable !== false}
                    onChange={(e) => this.updateColumn(index, "sortable", e.target.checked)}
                  />
                </td>
                <td>
                  <Form.Control
                    type="text"
                    size="sm"
                    value={col.width || ""}
                    onChange={(e) => this.updateColumn(index, "width", e.target.value)}
                    placeholder="auto"
                  />
                </td>
                <td>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    className="me-1"
                    onClick={() => this.moveColumn(index, -1)}
                    disabled={index === 0}
                  >
                    <i className="bi bi-arrow-up"></i>
                  </Button>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    className="me-1"
                    onClick={() => this.moveColumn(index, 1)}
                    disabled={index === columns.length - 1}
                  >
                    <i className="bi bi-arrow-down"></i>
                  </Button>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => this.removeColumn(index)}
                  >
                    <i className="bi bi-trash"></i>
                  </Button>
                </td>
              </tr>
            ))}
            {columns.length === 0 && (
              <tr>
                <td colSpan="7" className="text-center text-muted py-3">
                  No columns defined. Click "Add Column" to start.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    );
  }
}
